export default __webpack_public_path__ + "static/international-yards-desktop-e7dab8fb79ee126f1d32fba194c86d2c.svg";